import { Component, Injector, Input, ViewEncapsulation } from "@angular/core";
import { AppComponentBase } from "@shared/app-component-base";
import localePtBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { CandidatoDto, VagaSimplificadaDto } from "@shared/service-proxies/service-proxies";
import { Router } from "@angular/router";
import { CandidatoService } from "candidato/service/candidato.service";
import { ConfirmationDialogComponent } from "./detalhes/candidatar/candidatar-vaga.component";
import { MatDialog } from "@angular/material/dialog";
import { ModelosTrabalho } from 'shared/constant/modelos-trabalho.model';
import { VagaService } from "@shared/services/vaga.service";
@Component({
  selector: "card-candidato-vaga",
  templateUrl: "./card-candidato-vaga.component.html",
  styleUrls: ["./card-candidato-vaga.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

export class CardCandidatoVagaComponent extends AppComponentBase{
  @Input() vaga: VagaSimplificadaDto;
  @Input() isInscrito: boolean;
  pcdTitle: string = this.l("Vaga para pessoas com deficiência.");
  candidato: CandidatoDto = new CandidatoDto();
  modeloHomeOffice: ModelosTrabalho = ModelosTrabalho.homeoffice;
  modeloPresencial: ModelosTrabalho = ModelosTrabalho.presencial;
  modeloHibrido: ModelosTrabalho = ModelosTrabalho.hibrido;
  descricaoTruncada = '';

  constructor(
    injector: Injector,
    private _router: Router,
    private candidatoService: CandidatoService,
    private dialog: MatDialog,
    private _vagaService: VagaService,
  ) {
    super(injector);
    registerLocaleData(localePtBr);
  }

  detalhes() {
    this.candidatoService.setInscrito(this.isInscrito);
    this._router.navigate(['candidato', 'detalhes-vaga', this.vaga.id], {
      queryParams: { title: this.vaga.cargoNome }
    });
  }

  candidatar() {
    this.candidato = this.candidatoService.getCandidato();
    const vaga = this._vagaService.convertVagaSimplificadaToVagaDto(this.vaga)
    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        vaga: vaga,
        candidato: this.candidato,
      },
    });
  }
}
